import { clamp } from 'lodash-es';

import {
  DEFAULT_TRACK_MAX,
  DEFAULT_TRACK_MIN,
  DEFAULT_TRACK_STEP,
  TRACK_TYPE,
} from './constant';
import type { VBaseTrackProps, VBaseTrackType } from './type';

export const getDefaultValue = <T extends VBaseTrackType>(
  type: T,
  min: number = 0,
) =>
  (type === TRACK_TYPE.RANGE
    ? ([] as number[])
    : type === TRACK_TYPE.MULTIPLE_RANGE
      ? ([] as number[][])
      : min) as NonNullable<VBaseTrackProps<T>['value']>;

export const valueByClampFactory =
  ({
    max = DEFAULT_TRACK_MAX,
    min = DEFAULT_TRACK_MIN,
  }: Pick<VBaseTrackProps<any>, 'max' | 'min'>) =>
  (value: number) =>
    clamp(value ?? min, min, max);

export const valueByRateFactory = ({
  max = DEFAULT_TRACK_MAX,
  min = DEFAULT_TRACK_MIN,
  step = DEFAULT_TRACK_STEP,
}: Pick<VBaseTrackProps<any>, 'max' | 'min' | 'step'>) => {
  const getClampedValue = valueByClampFactory({ max, min });

  return (rate: number) =>
    getClampedValue(Math.round((rate * max) / step) * step);
};

export const offsetRateByFactory =
  ({
    max = DEFAULT_TRACK_MAX,
    min = DEFAULT_TRACK_MIN,
  }: Pick<VBaseTrackProps<any>, 'max' | 'min'>) =>
  (value: number) =>
    Math.min(((value ?? min) - min) / max, 1);
